module.exports = __webpack_public_path__ + "static/media/globe-americas.0035c045.svg";